import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#050914] gx-radial px-6">
      <Logo to={null} variant="icon" size="lg" className="rounded-xl" />
      <div className="mt-10 w-full max-w-md rounded-xl border border-slate-800 bg-[#0A1124] p-8 text-center" data-testid="payment-cancel-card">
        <XCircle className="mx-auto h-12 w-12 text-slate-500" />
        <h1 className="mt-6 font-display text-2xl font-bold text-white">Checkout cancelled</h1>
        <p className="mt-2 text-slate-400">No payment was made. You can pick a plan whenever you're ready.</p>
        <div className="mt-6 flex gap-3 justify-center">
          <Button asChild variant="outline" className="border-slate-700 text-white hover:bg-slate-800 hover:text-white">
            <Link to="/dashboard">Go to dashboard</Link>
          </Button>
          <Button asChild className="bg-cyan-400 text-black font-semibold hover:bg-cyan-300">
            <Link to="/billing" data-testid="payment-cancel-back">Back to plans</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
